import React from 'react';

import { components } from '@atlaskit/select';
import { ResponderAvatar } from '@atlassian/eoc-responder-names';

import { type SelectControlProps } from './types';

export const SelectControl = ({ children, responder, ...props }: SelectControlProps) => {
	return (
		<components.Control {...props}>
			{responder && !props.selectProps.inputValue && (
				<ResponderAvatar responder={responder} size="small" />
			)}
			{children}
		</components.Control>
	);
};
